<gtd-ui-field-default-string-or-empty [data]="offerVerticals[data?.toString()]"></gtd-ui-field-default-string-or-empty>
